var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconInbox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_12199)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66699 10.5833C7.08121 10.5833 7.41699 10.919 7.41699 11.3333V13.9166H8.58366V11.3333C8.58366 10.919 8.91945 10.5833 9.33366 10.5833C9.74787 10.5833 10.0837 10.919 10.0837 11.3333V14.6666C10.0837 15.0808 9.74787 15.4166 9.33366 15.4166H6.66699C6.25278 15.4166 5.91699 15.0808 5.91699 14.6666V11.3333C5.91699 10.919 6.25278 10.5833 6.66699 10.5833Z",
    className: "icon-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.05029 6.7915C3.05029 6.37729 3.38608 6.0415 3.80029 6.0415H4.05029C4.46451 6.0415 4.80029 6.37729 4.80029 6.7915C4.80029 7.20572 4.46451 7.5415 4.05029 7.5415H3.80029C3.38608 7.5415 3.05029 7.20572 3.05029 6.7915Z",
    className: "icon-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.583496 6.56667C0.583496 4.72783 2.08715 3.25 3.92609 3.25H12.0742C13.9132 3.25 15.4168 4.72783 15.4168 6.56667V10.6C15.4168 11.4261 14.7421 12.0833 13.9261 12.0833H2.07424C1.25826 12.0833 0.583496 11.4261 0.583496 10.6V6.56667ZM3.92609 4.75C2.90133 4.75 2.0835 5.57044 2.0835 6.56667V10.5833H13.9168V6.56667C13.9168 5.57044 13.099 4.75 12.0742 4.75H3.92609Z",
    className: "icon-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2.83325C10.2761 2.83325 10.5 3.05711 10.5 3.33325V7.33325C10.5 7.60939 10.2761 7.83325 10 7.83325C9.72386 7.83325 9.5 7.60939 9.5 7.33325V3.33325C9.5 3.05711 9.72386 2.83325 10 2.83325Z",
    className: "icon-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 1.33325C9.5 1.05711 9.72386 0.833252 10 0.833252H13.3333C13.6095 0.833252 13.8333 1.05711 13.8333 1.33325V3.33325C13.8333 3.60939 13.6095 3.83325 13.3333 3.83325H10C9.72386 3.83325 9.5 3.60939 9.5 3.33325V1.33325ZM10.5 1.83325V2.83325H12.8333V1.83325H10.5Z",
    className: "icon-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25 4C3.25 3.58579 3.58579 3.25 4 3.25C5.8597 3.25 7.41667 4.70816 7.41667 6.56667V11.3333C7.41667 11.7475 7.08088 12.0833 6.66667 12.0833C6.25245 12.0833 5.91667 11.7475 5.91667 11.3333V6.56667C5.91667 5.59011 5.08582 4.75 4 4.75C3.58579 4.75 3.25 4.41421 3.25 4Z",
    className: "icon-fill"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_12199"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInbox);
export default __webpack_public_path__ + "static/media/icon-inbox.3e1d8003a943ce305ed186580c66d71a.svg";
export { ForwardRef as ReactComponent };